import React from 'react'
import Allproduct from './AllProducts/Allproduct'
import Header from '../../layout/header/Header'

const Product = () => {
  return (
    < > 
      <Header/>
      <Allproduct/>
    </>
  )
}

export default Product